import React, { useState } from "react"
import Modal from "react-bootstrap/Modal"
import Button from "react-bootstrap/Button"
import style from "./send-application.module.css"
import axios from "axios"

const SendApplication = ({ show, setShow, jobId }) => {
  console.log("job id", jobId)

  const [status, setStatus] = useState("idle")
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [email, setEmail] = useState("")
  const [phone, setPhone] = useState("")
  const [resume, setResume] = useState(null)
  const [resumeType, setResumeType] = useState("")

  const handleSubmit = async e => {
    e.preventDefault()

    setStatus("sending_application")
    // check if job application is not found to proceed
    const checkApplication = await fetch(
      (process.env.GATSBY_API_URL || "http://localhost:3000/production") +
        `/application/check`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          firstName,
          lastName,
          email,
          jobOrderId: jobId,
        }),
      }
    ).then(res => res.json())

    if (checkApplication?.isDuplicate) {
      alert("Your application for this position has already been recorded!")
      setStatus("application_sent")
      return
    }

    const formData = new FormData()

    const params = {
      jobId: jobId,
      firstName: firstName,
      lastName: lastName,
      email: email,
      phone: phone,
      type: "Resume",
      externalID: "Resume",
      format: resumeType,
    }
    console.log("params", params)

    console.log("resume", resume)

    formData.append("resume", resume)

    console.log("form data", formData)

    try {
      await axios.post(
        "https://public-rest41.bullhornstaffing.com/rest-services/52H93D/apply/" +
          jobId +
          "/raw",
        formData,
        {
          params: params,
        }
      )

      setShow(false)
    } catch (err) {
      console.log("err here", err)
    }
  }

  // const getFilePath = (filePath) => {
  //     return filePath.substr(filePath.lastIndexOf('\\') + 1).split('.')[0];
  // }

  const getFile = event => {
    console.log("event", event.target.files[0])
    // outputfile.value = getFile(inputfile.value);
    // extension.value = inputfile.value.split('.')[1];
    // setResumeType(inputfile.value.split('.')[1])
    setResumeType(event.target.files[0].name.split(".")[1])
    setResume(event.target.files[0])
  }

  return (
    <Modal show={show} onHide={() => setShow(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Send Application</Modal.Title>
      </Modal.Header>

      <form onSubmit={handleSubmit}>
        <Modal.Body>
          <div className="form-group mt-0">
            <input
              type="email"
              name="email"
              onChange={event => setEmail(event.target.value)}
              className="form-control"
              required={true}
            />
            <label
              htmlFor="email"
              className={email.length ? style.activeLabel : style.normalLabel}
            >
              Email
            </label>
          </div>
          <div className="form-group mt-3 mb-0">
            <input
              type="text"
              name="firstname"
              onChange={event => setFirstName(event.target.value)}
              className="form-control"
              required={true}
            />
            <label
              htmlFor="firstname"
              className={
                firstName.length ? style.activeLabel : style.normalLabel
              }
            >
              First Name
            </label>
          </div>
          <div className="form-group mt-3 mb-0">
            <input
              type="text"
              name="lastname"
              onChange={event => setLastName(event.target.value)}
              className="form-control"
              required={true}
            />
            <label
              htmlFor="lastname"
              className={
                lastName.length ? style.activeLabel : style.normalLabel
              }
            >
              Last Name
            </label>
          </div>
          <div className="form-group mt-3 mb-0">
            <input
              type="text"
              name="phone"
              onChange={event => setPhone(event.target.value)}
              className="form-control"
            />
            <label
              htmlFor="phone"
              className={phone.length ? style.activeLabel : style.normalLabel}
            >
              Phone
            </label>
          </div>
          <div className={style.formGroup}>
            <input
              type="file"
              accept="application/pdf, .docx"
              name="resume"
              onChange={event => getFile(event)}
              // ref={resume}
              placeholder="Resume*"
              className="w-100"
              required={true}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" type="submit" disabled={status !== "idle"}>
            {status === "sending_application" && "SENDING APPLICATION..."}
            {status === "idle" && "SUBMIT"}
            {status === "application_sent" && "APPLICATION SENT..."}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  )
}

export default SendApplication
